import { projectRequest } from 'store/utils/request';

export const checkEntityNameRequest = (name, exception) =>
  projectRequest.get('/entities/count/', {
    params: Object.assign(
      {
        name__iexact: name,
      },
      exception
        ? {
            id__not__in: exception,
          }
        : null,
    ),
  });

export const getEntitiesRequest = async (params, requestId) => {
  try {
    return await projectRequest.get(`/entities/`, {
      params,
      requestId,
    });
  } catch (error) {
    throw error;
  }
};

export const getEntityRequest = async id => {
  try {
    return await projectRequest.get(`/entities/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const addEntityRequest = async data => {
  try {
    return await projectRequest.post(`/entities/`, data);
  } catch (error) {
    throw error;
  }
};

export const updateEntityRequest = async (id, data) => {
  try {
    return await projectRequest.put(`/entities/${id}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteEntityRequest = async id => {
  try {
    return await projectRequest.delete(`/entities/${id}/`);
  } catch (error) {
    throw error;
  }
};
